module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "admin-arrow-down.8ab3589e.svg";